import { ReducerActionRotaSP } from 'store/modules/types';

import { Types, ConsultarPerfisRequest } from './types';

export function consultarPerfilsRequest(
	token: string,
	data: ConsultarPerfisRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PERFIS_REQUEST,
		token,
		payload: {
			page: data.current && data.current - 1,
			size: data.limite,
			current: data.current,
			id: data.id,
			descricao: data.descricao,
			status: data.status,
			acessaSgu: data.acessaSgu,
		},
	};
}
export function consultarPerfilsSuccess(payload: object): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PERFIS_SUCCESS,
		payload,
	};
}
export function consultarPerfilsFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PERFIS_FAILURE,
		payload: null,
	};
}
export function consultarPerfilsClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PERFIS_CLEAR,
		payload: null,
	};
}
